<template>
  <div>
    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn small
             flat
             icon
             v-on:click.native="$router.push({ name: 'viewfreight' })"
             color="teal">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-container>
        <v-layout>
          <v-flex xs12
                  sm6
                  offset-sm3>
            <v-card>
              <v-card-text>
                <timeline :id="'KangaruuFreight'"
                          :sourceType="'profile'"
                          :options="{ tweetLimit: '25' }">
                </timeline>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

  </div>
</template>


<script>
import VueFacebook from 'vue-goodshare/src/providers/Facebook.vue'
import VueTwitter from 'vue-goodshare/src/providers/Twitter.vue'
import VueLinkedIn from 'vue-goodshare/src/providers/LinkedIn.vue'
import { Timeline } from 'vue-tweet-embed'
export default {
  components: {
    VueFacebook, VueTwitter, VueLinkedIn, Timeline
  },
  data () {
    return {
      items: [
        { isTweet: true,
          tweetID: '1015667296147144704',
          title: 'Blockchain in Freight' },
        { isTweet: true,
          tweetID: '1015635114070458368',
          title: 'Who is using Blockchain' },
        { isTweet: true,
          tweetID: '1014913722752516096',
          title: 'Blockchain' },
        { isTweet: true,
          tweetID: '1014908534650097664',
          title: 'Getting the best shipping rate' },
        { isTweet: true,
          tweetID: '1014224974322659328',
          title: 'Kangaruu Software Tip' },
        { isTweet: true,
          tweetID: '1014224187743920128',
          title: 'Organized Chat' },
        { isTweet: true,
          tweetID: '1014189884859269120',
          title: 'New Kangaruu Feature' },

        { isTweet: false,
          title: 'Average Van Rates Hit New High in Spot Market',
          date: 'June 28, 2018',
          linkText: 'Kangaruu',
          linkAddress: 'https://kangaruu.com',
          text: `Dry Van CPI - $2.31 

                Trucks are in limited supply in key markets causing rates to soar over $.20 per mile in June.
                
                Our Weekly rates are derived from Spot market averages for the month.
                `},

        { isTweet: false,
          title: 'Press Release',
          date: 'June 19, 2018',
          linkText: 'Official Press Release',
          linkAddress: 'https://www.prnewswire.com/news-releases/digital-freight-startup-announces-the-public-launch-of-its-freight-platform-kangaruucom-300667682.html',

          text: `Digital Freight Startup Announces the Public Launch of Its Freight Platform Kangaruu.com Kangaruu creates a persistent organized communication tool to manage logistics between shippers and brokers in the $45 billion spot market
                
                TEMECULA, Calif., June 19, 2018 (Newswire.com) - Kangaruu is pleased to announce the public launch of its freight management platform.Kangaruu.com was created by technology and trucking industry experts in 2018 to digitize the trucking industry.
                
                Kangaruu uses the latest cloud - based technologies and artificial intelligence algorithms to create a simple, yet powerful, freight management process for both shippers and brokers.
                
                Kangaruu understands that the transportation industry is built on relationships.These relationships in the spot market produce 180 million truckloads each year.Current technology is fragmented and based on email, phone calls and faxes.Kangaruu moves past these old technologies and provides a modern cross - platform solution, centered around the freight quote in real time.
                
                “We worked with industry experts to create a digital solution that saves time and eliminates confusion.We provide collaboration tools to get the best rate quote for the shipper while preserving their broker relationship, ” said Kip Haas, Kangaruu’s CEO.
                
                New “digital brokers” have failed to understand the importance of the shipper-to - broker relationship.In their efforts to eliminate the broker with automation and artificial discounts, they have struggled to build lasting relationships with shippers.This is partly due to their lack of infrastructure to reap the benefits of digitization.But, it is mainly due to their core belief that the traditional broker relationship isn’t valuable in today’s marketplace.
                
                “We want to empower and facilitate the shipping transaction for all parties, including the shipper, broker and the carrier.Our job is to help them work together in a simple, transparent and seamless manner, ” said Mr.Haas.
                
                One of Kangaruu’s early adopters summed it up best: “Kangaruu has cleaned up my inbox, simplified my workflow and increased my productivity.” – Brooke, shipper.
                
                
                Email Contact: Info@kangaruu.com`}
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/News.vue